import notify from "devextreme/ui/notify";
import { ToastType } from "devextreme/ui/toast";

export function showNotification(message: string, type: ToastType) {
  notify(
    {
      message: message,
      height: 75,
      width: 350,
      minWidth: 150,
      type: type,
      displayTime: 3000,
      closeOnClick: true,
      animation: {
        show: { type: "fade", duration: 400, from: 0, to: 1 },
        hide: { type: "fade", duration: 200, from: 1, to: 0 },
      },
    },
    { position: "top center", direction: "down-stack" },
  );
}
